import { Stack, Typography } from '@mui/material'

import { SpaceBox } from 'components/Box'
import Space from 'components/Space'
import { TableHeaderProps } from './types'

export const TableHeader = ({
  actions,
  description,
  descriptionEndAdornment,
  filter,
  title,
}: TableHeaderProps): JSX.Element => (
  <>
    <Stack
      direction='row'
      sx={{
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Typography
        data-cy='table-header-title'
        variant='h5'
      >
        {title}
      </Typography>

      {actions}

      <SpaceBox />

      {filter}
    </Stack>

    {description && (
      <Typography
        data-cy='table-header-description'
        sx={{ pt: 1 }}
        variant='subtitle1'
      >
        {description}

        {descriptionEndAdornment && <Space />}
        {descriptionEndAdornment}
      </Typography>
    )}
  </>
)
